import React, { useState, useEffect, useCallback } from 'react';
import Sidebar from '../../components/Sidebar';
import Header from './Header';
import FilterSection from './FilterSection';
import ProgramsTable from './ProgramsTable';
import PendingGradesModal from './PendingGradesModal';
import ConfirmationModal from './ConfirmationModal';
import styles from '../../styles/CierreCicloEscolarStyles/CierreCicloEscolar.module.css';
import { getCampus } from '../../api/campus';
import {
  getProgramasCierreCiclo,
  validarCierreCiclo,
  ejecutarCierreCiclo,
  getSeccionesAcademicas,
  getCicloActual,
  getCiclosDisponiblesCierre,
} from '../../api/cierreCiclo';

function CierreCicloEscolarScreen() {
  // â”€â”€ CatÃ¡logos para filtros â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const [campusList, setCampusList] = useState([]);
  const [seccionesList, setSeccionesList] = useState([]);
  const [ciclosList, setCiclosList] = useState([]);

  // â”€â”€ Filtros activos â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  // El ciclo escolar se detecta automáticamente por fecha del servidor.
  const [filters, setFilters] = useState({
    campus: '',
    seccion: '',
  });

  // Ciclo actual auto-detectado
  const [cicloActualId, setCicloActualId] = useState(null);
  const [cicloActualNombre, setCicloActualNombre] = useState('');

  // Ciclo elegido por el usuario para hacer el cierre.
  // Por defecto = ciclo actual; el usuario puede elegir cualquier ciclo desde 2026-1
  // (cuando el sistema empezó a operar) hasta el ciclo actual.
  const [cicloSeleccionadoId, setCicloSeleccionadoId] = useState('');

  // â”€â”€ Estado de la tabla â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const [programs, setPrograms] = useState([]);
  const [loadingPrograms, setLoadingPrograms] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // â”€â”€ Estado de modales â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const [selectedProgram, setSelectedProgram] = useState(null);

  const [showPendingGradesModal, setShowPendingGradesModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [pendingGrades, setPendingGrades] = useState([]);
  const [loadingValidacion, setLoadingValidacion] = useState(false);
  const [loadingCierre, setLoadingCierre] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  // â”€â”€ Carga de catÃ¡logos al montar â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  useEffect(() => {
    Promise.all([
      getCampus(),
      getSeccionesAcademicas(),
      getCiclosDisponiblesCierre(),
      getCicloActual().catch(() => null),
    ])
      .then(([campus, secciones, ciclos, cicloActualData]) => {
        setCampusList(campus);
        setSeccionesList(secciones);
        setCiclosList(ciclos);

        let idDetectado = cicloActualData?.ciclo_actual?.id_ciclo_escolar || null;
        let nombreDetectado = cicloActualData?.ciclo_actual?.nombre_ciclo || '';

        if (!idDetectado && Array.isArray(ciclos) && ciclos.length > 0) {
          const hoyStr = new Date().toISOString().split('T')[0];
          const detectado = ciclos.find(
            (c) => c.fecha_inicio && c.fecha_fin && hoyStr >= c.fecha_inicio && hoyStr <= c.fecha_fin
          );
          if (detectado) {
            idDetectado = detectado.id;
            nombreDetectado = detectado.nombre;
          }
        }

        if (idDetectado) {
          setCicloActualId(idDetectado);
          setCicloActualNombre(nombreDetectado);
          setCicloSeleccionadoId((prev) => prev || idDetectado);
        } else {
          setErrorMessage('No se pudo detectar un ciclo escolar vigente para realizar el cierre.');
        }
      })
      .catch((err) => console.error('[CierreCiclo] Error cargando catÃ¡logos:', err));
  }, []);

  // Cargar ciclo actual
  useEffect(() => {
    getCicloActual()
      .then((ciclo) => {
        if (ciclo) {
          setCicloActualId(ciclo.id);
          setCicloActualNombre(ciclo.nombre || '');
        }
      })
      .catch((err) => console.error('[CierreCiclo] Error obteniendo ciclo actual:', err));
  }, []);

  // â”€â”€ Carga de programas â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const cargarProgramas = useCallback(async (page = 1) => {
    setLoadingPrograms(true);
    setErrorMessage(null);
    try {
      const data = await getProgramasCierreCiclo({
        id_campus: filters.campus || undefined,
        id_seccion: filters.seccion || undefined,
        id_ciclo_escolar: cicloSeleccionadoId || undefined,
        page,
      });
      setPrograms(data.results || []);
      setTotalPages(data.total_pages || 1);
      setCurrentPage(data.current_page || page);
    } catch (err) {
      console.error('[CierreCiclo] Error cargando programas:', err);
      setErrorMessage('Error al cargar los programas. Intenta de nuevo.');
    } finally {
      setLoadingPrograms(false);
    }
  }, [filters, cicloSeleccionadoId]);

  // Carga inicial
  useEffect(() => {
    if (cicloSeleccionadoId) cargarProgramas(1);
  }, [cicloSeleccionadoId]); // eslint-disable-line react-hooks/exhaustive-deps

  // â”€â”€ Handlers â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  const handleApplyFilters = () => {
    setCurrentPage(1);
    cargarProgramas(1);
  };

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    cargarProgramas(page);
  };

  const handleCerrarCiclo = async (program) => {
    const cicloId = cicloSeleccionadoId || cicloActualId;
    if (!cicloId) {
      setErrorMessage('No se pudo detectar el ciclo escolar. Intenta recargar la página.');
      return;
    }
    setSelectedProgram({ ...program, cicloEscolarId: cicloId });
    setErrorMessage(null);
    setLoadingValidacion(true);
    try {
      const result = await validarCierreCiclo(program.id, cicloId);
      setPendingGrades(result.pendientes || []);
      if (result.tiene_pendientes) {
        setShowPendingGradesModal(true);
      } else {
        setShowConfirmationModal(true);
      }
    } catch (err) {
      console.error('[CierreCiclo] Error al validar:', err);
      setErrorMessage('Error al validar calificaciones. Intenta de nuevo.');
    } finally {
      setLoadingValidacion(false);
    }
  };

  const handleClosePendingGradesModal = () => {
    setShowPendingGradesModal(false);
    setSelectedProgram(null);
    setPendingGrades([]);
  };

  const handleContinuarConPendientes = () => {
    setShowPendingGradesModal(false);
    setShowConfirmationModal(true);
  };

  const handleCancelConfirmation = () => {
    setShowConfirmationModal(false);
    setSelectedProgram(null);
    setPendingGrades([]);
  };

  const handleConfirmCierre = async () => {
    if (!selectedProgram) return;
    setLoadingCierre(true);
    try {
      await ejecutarCierreCiclo(selectedProgram.id, selectedProgram.cicloEscolarId);
      setShowConfirmationModal(false);
      setSelectedProgram(null);
      setPendingGrades([]);
      // Recargar la pÃ¡gina actual para reflejar el nuevo estatus CERRADO
      cargarProgramas(currentPage);
    } catch (err) {
      console.error('[CierreCiclo] Error al ejecutar cierre:', err);
      setErrorMessage(err.message || 'Error al ejecutar el cierre. Intenta de nuevo.');
      setShowConfirmationModal(false);
    } finally {
      setLoadingCierre(false);
    }
  };

  // Lista de ciclos seleccionables: el endpoint ya devuelve solo los ciclos
  // con historial de inscripciones, ordenados de más reciente a más antiguo.
  const ciclosSeleccionables = ciclosList;

  // ── Datos del programa seleccionado para los modales ────
  const programaParaModal = selectedProgram
    ? {
        ...selectedProgram,
        campus: campusList.find((c) => String(c.id) === String(filters.campus))?.nombre || '',
        seccion: seccionesList.find((s) => String(s.id) === String(filters.seccion))?.nombre || selectedProgram.seccion || '',
        cicloEscolar:
          ciclosList.find((c) => String(c.id) === String(selectedProgram.cicloEscolarId))?.nombre ||
          cicloActualNombre ||
          '',
      }
    : null;

  return (
    <div className={styles.layout}>
      <div className={styles.sidebarColumn}>
        <Sidebar />
      </div>

      <div className={styles.contentColumn}>
        <div className={styles.contentArea}>
          <Header />

          <FilterSection
            filters={filters}
            onFilterChange={handleFilterChange}
            onApply={handleApplyFilters}
            campusList={campusList}
            seccionesList={seccionesList}
            ciclosList={ciclosSeleccionables}
            cicloSeleccionadoId={cicloSeleccionadoId}
            onCicloChange={(id) => setCicloSeleccionadoId(id)}
            cicloActualId={cicloActualId}
            loading={loadingPrograms}
          />

          {errorMessage && (
            <div style={{ color: '#c00', padding: '0.75rem 1.5rem', fontWeight: 500 }}>
              {errorMessage}
            </div>
          )}

          <div className={styles.mainContent}>
            <ProgramsTable
              programs={programs}
              onCerrarCiclo={handleCerrarCiclo}
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              loading={loadingPrograms || loadingValidacion}
            />
          </div>
        </div>
      </div>

      {showPendingGradesModal && programaParaModal && (
        <PendingGradesModal
          program={programaParaModal}
          pendingGrades={pendingGrades}
          onClose={handleClosePendingGradesModal}
          onContinuar={handleContinuarConPendientes}
        />
      )}

      {showConfirmationModal && programaParaModal && (
        <ConfirmationModal
          program={programaParaModal}
          onConfirm={handleConfirmCierre}
          onCancel={handleCancelConfirmation}
          loading={loadingCierre}
        />
      )}
    </div>
  );
}

export default CierreCicloEscolarScreen;
